"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sort = exports.FilterGroup = exports.ColumnFilter = exports.BasicFilter = exports.Filter = void 0;
const error_1 = require("../error");
class Filter {
    static deserialize(obj) {
        if (!obj.type || obj.type === 'basic')
            return BasicFilter.deserialize(obj);
        else if (obj.type === 'column')
            return ColumnFilter.deserialize(obj);
        else if (obj.type === 'group')
            return FilterGroup.deserialize(obj);
        throw new error_1.default('Invalid filter type: ' + obj.type);
    }
    static adjustNodeScaffoldName(nodeId) {
        if (nodeId.endsWith('_scaffold'))
            nodeId = nodeId.replace('_scaffold', '');
        return nodeId;
    }
}
exports.Filter = Filter;
class BasicFilter extends Filter {
    static deserialize(obj) {
        return new BasicFilter(obj.column, obj.test, obj.value);
    }
    constructor(column, testType, value) {
        super();
        this.column = column;
        this.test = testType;
        this.value = value;
    }
    serialize() {
        return {
            type: 'basic',
            column: this.column,
            test: this.test,
            value: this.value,
        };
    }
    // eslint-disable-next-line no-unused-vars
    validate(lookup) {
        let valid = !!this.column && !!this.column.column && !!this.test;
        let nodeId = BasicFilter.adjustNodeScaffoldName(this.column.nodeId);
        return valid && !!lookup(nodeId);
    }
}
exports.BasicFilter = BasicFilter;
class ColumnFilter extends Filter {
    static deserialize(obj) {
        return new ColumnFilter(obj.columnA, obj.columnB, obj.test);
    }
    constructor(columnA, columnB, testType) {
        super();
        this.columnA = columnA;
        this.columnB = columnB;
        this.test = testType;
    }
    serialize() {
        return {
            type: 'column',
            columnA: this.columnA,
            columnB: this.columnB,
            test: this.test
        };
    }
    // eslint-disable-next-line no-unused-vars
    validate(lookup) {
        let colAValid = !!this.columnA && !!this.columnA.column;
        let colBValid = !!this.columnB && !!this.columnB.column;
        let valid = colAValid && colBValid && !!this.test;
        let nodeIdA = ColumnFilter.adjustNodeScaffoldName(this.columnA.nodeId);
        let nodeIdB = ColumnFilter.adjustNodeScaffoldName(this.columnB.nodeId);
        return valid && !!lookup(nodeIdA) && !!lookup(nodeIdB);
    }
}
exports.ColumnFilter = ColumnFilter;
class FilterGroup extends Filter {
    static deserialize(obj) {
        let filters = obj.filters.map(Filter.deserialize);
        return new FilterGroup(filters, obj.filterGroupType);
    }
    constructor(filters, filterGroupType) {
        super();
        this.filters = filters;
        this.filterGroupType = filterGroupType;
    }
    serialize() {
        return {
            type: 'group',
            filters: this.filters.map(f => f.serialize()),
            filterGroupType: this.filterGroupType,
        };
    }
    // eslint-disable-next-line no-unused-vars
    validate(lookup) {
        return !!this.filterGroupType && this.filters.every(f => f.validate(lookup));
    }
}
exports.FilterGroup = FilterGroup;
class Sort {
    static deserialize(obj) {
        return new Sort(obj.column, obj.asc);
    }
    constructor(column, asc) {
        this.column = column;
        this.asc = asc;
    }
    serialize() {
        return {
            column: this.column,
            asc: this.asc
        };
    }
    // eslint-disable-next-line no-unused-vars
    validate(lookup) {
        let valid = !!this.column && !!this.column.column && typeof this.asc !== undefined;
        let nodeId = Filter.adjustNodeScaffoldName(this.column.nodeId);
        return valid && !!lookup(nodeId);
    }
}
exports.Sort = Sort;
